"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerName = exports.OverflowHeader = exports.UserWrapper = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("@paprika/stylers/lib/helpers");
var stylers_1 = __importDefault(require("@paprika/stylers"));
var tokens_1 = __importDefault(require("@paprika/tokens"));
var GlobalNavigation_styles_1 = require("../../GlobalNavigation.styles");
var withTheme_1 = __importDefault(require("../theme/withTheme"));
exports.UserWrapper = withTheme_1.default(styled_components_1.default.div(function (_a) {
    var isTrainingOrg = _a.isTrainingOrg;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin: 2px 2px 2px 0;\n\n      .aclui-tooltip {\n        width: 170px;\n        text-align: center;\n      }\n\n      [data-pka-anchor='button']:focus {\n        box-shadow: ", " !important;\n      }\n    "], ["\n      margin: 2px 2px 2px 0;\n\n      .aclui-tooltip {\n        width: 170px;\n        text-align: center;\n      }\n\n      [data-pka-anchor='button']:focus {\n        box-shadow: ", " !important;\n      }\n    "])), isTrainingOrg ? tokens_1.default.highlight.active.withBorder.boxShadow : GlobalNavigation_styles_1.focusBoxShadow);
}));
exports.OverflowHeader = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  display: block;\n  min-width: 192px;\n  margin-top: -", ";\n  padding: 6px ", ";\n  border-bottom: 1px solid ", ";\n  background-color: ", ";\n  font-weight: bold;\n"], ["\n  ", ";\n  display: block;\n  min-width: 192px;\n  margin-top: -", ";\n  padding: 6px ", ";\n  border-bottom: 1px solid ", ";\n  background-color: ", ";\n  font-weight: bold;\n"])), stylers_1.default.fontSize(-2), tokens_1.default.space, helpers_1.spacer(2), tokens_1.default.border.color, tokens_1.default.color.blackLighten80);
exports.CustomerName = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: normal;\n"], ["\n  font-weight: normal;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=User.styles.js.map